import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';

export const TrainingMaterials = () => {
  return (
    <Fragment>
      <Navbar />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <h2>Training Presentation</h2>
        <iframe
          src='https://docs.google.com/a/aacounty.org/presentation/d/e/2PACX-1vR-hgRN8PyX4xHiBthFaeKIKdut7Q_F3A9DlK9opRnMVphcoofZal4e9tATmvpsLMnUsLHTuqlb0mQo/embed?start=false&loop=false&delayms=3000'
          frameBorder='0'
          width='1280'
          height='749'
          allowFullScreen={true}
          title='Training'
        />
      </div>
    </Fragment>
  );
};
